module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.usuarioValido) ? _c('div', [_c('protocolo-modal', {
    attrs: {
      "protocoloGerado": _vm.protocolo,
      "agendamentoId": _vm.agendamentoId
    },
    on: {
      "imprimeProtocolo": _vm.imprime
    }
  }), _vm._v(" "), _c('explicacao-modal'), _vm._v(" "), _c('regra-dias-pendentes-modal'), _vm._v(" "), _c('regra-ferias-pendentes-modal'), _vm._v(" "), _c('side-modal', {
    attrs: {
      "inicioAtividade": _vm.dataInicioAtividade,
      "inicioSabado": _vm.agendaSabado,
      "inicioDomingoFeriado": _vm.agendaDomingoFeriado
    },
    on: {
      "agendaData": _vm.gravaData,
      "mostraProtocolo": _vm.abreProtocolo
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "main-container container container-top"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_vm._m(0), _vm._v(" "), _c('section', [_c('table-loader', {
    attrs: {
      "carregando": _vm.carregandoAprovador
    }
  }, [(_vm.escondeAprovador) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Sistema fechado para atualização. \n                    Agendamentos poderão ser solicitados a partir do dia 05.\n                  ")]) : (_vm.aprovadores && !_vm.aprovadores.length) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Você não tem\n                    aprovador cadastrado. Relate esse problema ao seu chefe ou\n                    superior.\n                  ")]) : _vm._l((_vm.aprovadores), function(aprovador) {
    return _c('div', {
      key: aprovador.id,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "form-group col-lg-5 col-md-5 col-sm-5"
    }, [_c('label', [_vm._v("Nome:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(aprovador.nome))])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-lg-3 col-md-3 col-sm-3"
    }, [_c('label', [_vm._v("Registro:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(aprovador.registro))])]), _vm._v(" "), _c('div', {
      staticClass: "form-group col-lg-4 col-md-4 col-sm-4"
    }, [_c('label', [_vm._v("Cargo:")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(aprovador.cargo))])])])
  })], 2)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card card-default"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('card-header', {
    attrs: {
      "titulo": ("Agendamento de Férias " + (_vm.feriasAgendadas.length &&
                    _vm.feriasAgendadas[0].periodo)),
      "subtitulo": "(Como funciona o agendamento?)"
    },
    on: {
      "abreModal": _vm.abreExplicacaoModal
    }
  }), _vm._v(" "), _c('section', [_c('table-loader', {
    attrs: {
      "carregando": _vm.carregando
    }
  }, [(_vm.feriasAgendadas && !_vm.feriasAgendadas.length) ? _c('div', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('i', {
    staticClass: "fa fa-flag-o fa-lg"
  }), _vm._v("  Você ainda não\n                    tem período de férias para agendar.\n                  ")]) : _c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Exercício")]), _vm._v(" "), _c('th', [_vm._v("Data de Início")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs hidden-xxs"
  }, [_vm._v("Dias Pendentes")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs hidden-xxs"
  }, [_vm._v("Férias Pendentes")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xxs"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v(" ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.feriasAgendadas), function(ferias) {
    return _c('tr', {
      key: ferias.id,
      class: ferias.situacao === 'PENDENTE' ?
        'situacao-pendente' :
        ''
    }, [_c('td', [_vm._v(_vm._s(ferias.periodo))]), _vm._v(" "), (ferias.inicio) ? _c('td', [_vm._v("\n                          " + _vm._s(_vm._f("formataData")(ferias.inicio)) + "\n                        ")]) : _c('td', [_c('i', {
      staticClass: "fa fa-ellipsis-h fa-lg",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs hidden-xxs"
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "width": "107px"
      }
    }, [_vm._v("\n                            " + _vm._s(ferias.diasPendentes ? 'SIM' : 'NÃO') + "\n                          ")])]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs hidden-xxs"
    }, [_c('div', {
      staticStyle: {
        "text-align": "center",
        "width": "107px"
      }
    }, [_vm._v("\n                            " + _vm._s(ferias.feriasPendentes ? 'SIM' : 'NÃO') + "\n                          ")])]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xxs"
    }, [_vm._v("\n                          " + _vm._s(_vm._f("descricaoStatus")(ferias.situacao)) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "td-btns td-btns-alone",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('div', [_c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mostraEditar(ferias)),
        expression: "mostraEditar(ferias)"
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Editar'),
        expression: "'Editar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": 'vazado-laranja-sm',
        "icone": "editar-tabela"
      },
      on: {
        "clicado": function($event) {
          return _vm.agenda('agendamento', ferias)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mostraVisualizar(ferias)),
        expression: "mostraVisualizar(ferias)"
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: ('Visualizar'),
        expression: "'Visualizar'",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-cinza-sm",
        "icone": "visualizar"
      },
      on: {
        "clicado": function($event) {
          return _vm.visualiza('agendamento', ferias)
        }
      }
    }), _vm._v(" "), _c('botao', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.mostraDiasFeriasPendentes(ferias)),
        expression: "mostraDiasFeriasPendentes(ferias)"
      }, {
        name: "tooltip",
        rawName: "v-tooltip.left",
        value: (
          _vm.alternaTooltipDiasFerias(ferias)
        ),
        expression: "\n                                alternaTooltipDiasFerias(ferias)\n                              ",
        modifiers: {
          "left": true
        }
      }],
      attrs: {
        "estilo": "vazado-vermelho-sm",
        "icone": "fa-exclamation-triangle"
      },
      on: {
        "clicado": function($event) {
          return _vm.agendaOuVisualiza('agendamento', ferias)
        }
      }
    })], 1)])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 footer-controller-inner"
  }, [_c('botao', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostraEditar(_vm.primeiroPeriodoPendente)),
      expression: "mostraEditar(primeiroPeriodoPendente)"
    }],
    attrs: {
      "estilo": "cheio-verde-dir",
      "rotulo": "Agendar",
      "icone": "fa-calendar-check-o",
      "toggle": "",
      "target": "",
      "disabled": !_vm.feriasAgendadas.length
    },
    on: {
      "clicado": function($event) {
        return _vm.agenda('agendamento', _vm.primeiroPeriodoPendente)
      }
    }
  })], 1)])], 1)], 1)])])])])])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_vm._v("Chefe Imediato "), _c('small', [_vm._v("(Aprovador)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7990d3c8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ferias/agendamento.vue
// module id = JJBI
// module chunks = 5